import { useMutation } from 'react-query';

import { deleteCustomCluster as mutationFn } from 'api/endPoints/deleteCustomCluster';

export const useMutationSavedSearchDelete = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

type QueryParams = number | null;
